import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UtilsService } from '@dabnet-kamu/libs/ui';
import { AuthService } from '@dabnet-kamu/libs/auth';

@Injectable({ providedIn: 'root' })
export class SessionService {

  private isLoggingOut = false;

  private authService = inject(AuthService);
  private utilsService = inject(UtilsService);
  private router = inject(Router);

  // Logout sadece bir kere tetiklenir
  async forceLogout(message = 'Oturum süreniz dolmuştur. Lütfen tekrar giriş yapınız.'): Promise<void> {

    console.log("FORCE LOGOUT");
    if (this.isLoggingOut) return;

    this.isLoggingOut = true;

    this.utilsService.showError(message);

    try {
      await this.authService.logout();
      window.location.href = '/';
      //await this.router.navigate(['/']);
    } finally {
      this.isLoggingOut = false;
    }
  }
}
